import StringMask from 'string-mask'

export default class Masker {
  static maskMoney(value) {
    if(value == null) return null
    if(value.toString().indexOf('.') == value.length - 2){
      value = value.replace(/\D/g, '')
      value = value.substr(0,(value.length - 2))+'.'+value.substr(value.length - 2, value.length)+'0'
    }
    const number = value.replace(/\D/g, '')
    const mask = new StringMask('#.##0,00', {reverse: true})
    let result = mask.apply(number)
    result = result.replace(/^0+(\d+,.*)/, '$1')
    return result
  }

  static unmaskMoney(value) {
    if(value === null || value === undefined) return null
    if(value.indexOf(',') == value.length - 2){
      value = value.replace(/\D/g, '')
      value = value.substr(0,(value.length - 2))+','+value.substr(value.length - 2, value.length)
    }
    return Number.parseFloat(value.toString().replace(/(\d{1,3})\.?/g, '$1').replace(',', '.'))
  }

  
  static maskInteger(value) {
    return value.replace(/\D/, '')
  }

  static maskPhone(value) {
    if(value == null) return null
    const number = value.replace(/\D/g, '')
    const mask = new StringMask('(00) 90000-0000')
    return mask.apply(number)
  }

  static maskDate(value) {
    if(value == null) return null
    const number = value.replace(/\D/g, '')
    const mask = new StringMask('90/90/9900')
    return mask.apply(number)
  }

  static maskIsoDate(value) {
    if(value == null) return null
    const dateOfTime = value.split("T")
    const dateOutTime = dateOfTime[0]
    const date   = dateOutTime.split("-").reverse().join()
    const number = date.replace(/\D/g, '')
    const mask = new StringMask('90/90/9900')
    return mask.apply(number)
  }

  static maskZipcode(value) {
    if(value == null) return null
    const number = value.replace(/\D/g, '')
    const mask = new StringMask('00000-000')
    return mask.apply(number)
  }

  static unmaskZipcode(value) {
    return value.replace(/\D/,'')
  }

  static maskRg(value) {
    if(value == null) return null
    return value;//.replace(/[^.-\dxX]/, "")
  }

  static unmaskRg(value) {
    if(value === null || value === undefined) return null
    return value.toString();//.replace(/(\D)/g, '')
  }

  static maskCpf(value) {
    if(value == null) return null
    const number = value.replace(/\D/g, '')
    const mask = new StringMask('000.000.000-00')
    return mask.apply(number)
  }

  static unmaskCpf(value) {
    if(value === null || value === undefined) return null
    return value.toString().replace(/(\D)/g, '')
  }

  static maskCnpj(value) {
    if(value == null) return null
    const number = value.replace(/\D/g, '')
    const mask = new StringMask('00.000.000/0000-00')
    return mask.apply(number)
  }

  static unmaskCnpj(value) {
    if(value === null || value === undefined) return null
    return value.toString().replace(/(\D)/g, '')
  }

  static maskBankAccount(value) {
    if(value == null) return null
    let maskedValue = value.replace(/\D/g, '')
    if(maskedValue.length > 1) {
      const mask = new StringMask('#0-0', {reverse: true})
      maskedValue = mask.apply(maskedValue)
    }
    return maskedValue
  }

  static maskBankAccountBb(value) {
    if(value == null) return null
    let maskedValue = value.replace(/-/g, '')
    if(maskedValue.length > 1) {
      const mask = new StringMask('#0-A', {reverse: true})
      maskedValue = mask.apply(maskedValue)
    }
    return maskedValue
  }

  static formatReal(num) {
      let real;
      real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
      return real;
  }
}



// WEBPACK FOOTER //
// ./src/utils/masker.js